import { render, staticRenderFns } from "./EWhatsappSuporte.vue?vue&type=template&id=c2646a96&scoped=true"
import script from "./EWhatsappSuporte.vue?vue&type=script&lang=js"
export * from "./EWhatsappSuporte.vue?vue&type=script&lang=js"
import style0 from "./EWhatsappSuporte.vue?vue&type=style&index=0&id=c2646a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2646a96",
  null
  
)

export default component.exports